import type { ThemeStore } from "../stores/theme.store";

export const getLocalCssColorVariables = (
  theme: ThemeStore,
): { [variable: string]: string } => ({
  "--solution-primary-color": theme.primaryColor,
  "--solution-secondary-color": theme.secondaryColor,
  "--solution-hover-color": theme.hoverColor,
  "--solution-highlight-color": theme.highlightColor,
  "--solution-primary-color-rgb": theme.primaryColorRGB,
  "--solution-secondary-color-rgb": theme.secondaryColorRGB,
  "--solution-hover-color-rgb": theme.hoverColorRGB,
  "--solution-highlight-color-rgb": theme.highlightColorRGB,
});
